(function () {
    var root = document.querySelector('[data-terjung-review-carousel]');
    if (!root) return;
    var track = root.querySelector('[data-terjung-review-track]');
    var prev = root.querySelector('[data-terjung-review-prev]');
    var next = root.querySelector('[data-terjung-review-next]');
    var dotsWrap = document.querySelector('[data-terjung-review-dots]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || cards.length < 2) return;

    function perView() {
      var w = window.innerWidth;
      if (w <= 760) return 1;
      if (w <= 1024) return 2;
      return 3;
    }
    function pages() { return Math.max(1, Math.ceil(cards.length / perView())); }

    var current = 0;
    var timer = null;

    // build dots
    function buildDots() {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Seite ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        (function (idx) { b.addEventListener('click', function () { go(idx, true); }); })(i);
        dotsWrap.appendChild(b);
      }
    }

    function scrollToPage(i) {
      var pv = perView();
      var firstCard = cards[Math.min(i * pv, cards.length - 1)];
      if (firstCard) track.scrollTo({ left: firstCard.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function setDot(i) {
      var dots = Array.prototype.slice.call(dotsWrap.children);
      dots.forEach(function (d, di) {
        if (di === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function setArrows() {
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= pages() - 1;
    }
    function go(i, user) {
      current = Math.max(0, Math.min(i, pages() - 1));
      scrollToPage(current);
      setDot(current);
      setArrows();
      if (user) restart();
    }
    function nextPage() { go(current >= pages() - 1 ? 0 : current + 1); }

    function start() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(nextPage, 5500);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });

    // sync dots on manual scroll/swipe
    var raf;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        var pv = perView();
        var nearest = 0, min = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; nearest = i; }
        });
        var pg = Math.floor(nearest / pv);
        if (pg !== current) { current = pg; setDot(current); setArrows(); }
      });
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () { buildDots(); go(0); }, 200);
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    buildDots();
    setArrows();
    start();
  })();
